import classNames from 'classnames';
import * as React from 'react';

interface NameEditFormItemProps {
  className?: string;
  value: React.ReactNode;
  suffix?: React.ReactNode;
}

export function NameEditFormItem(props: NameEditFormItemProps) {
  const { value, suffix, className } = props;

  return (
    <div
      className={classNames(
        'w-full h-7 flex items-center justify-between px-2 rounded bg-FFFFFF0A',
        className,
      )}
    >
      <div className='pl-1 overflow-hidden text-ellipsis whitespace-nowrap'>{value}</div>
      <div>{suffix}</div>
    </div>
  );
}
